// OffersList.styles
import styled from 'styled-components';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';

export const OffersListWrapper = styled.section`
  background-color: ${COLORS.grey5};
  flex: 1;
  width: 100%;
  @media ${device.laptop} {
    height: unset;
    overflow-y: unset;
    // THIS IS IMPORTANT FOR FEATURED OFFERS SECTION
    width: 100%;
    overflow-x: hidden;
  }
`;

export const GeneralSidePadding = styled.div<{ isFiltersOpen: boolean }>`
  padding-right: 16px;
  padding-left: 16px;
  @media ${device.mobileL} {
    padding-right: 40px;
    padding-left: 40px;
  }
  @media ${device.laptopMd} {
    padding: ${({ isFiltersOpen }) => (isFiltersOpen ? '0 98px 0 40px' : '0 96px 0 96px')};
  }
`;

export const OffersListHeader = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 32px;
  padding-bottom: 40px;
`;
export const PageTitle = styled.h4`
  color: ${COLORS.grey80};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.003px;
  padding-bottom: 4px;
`;
export const DagTitle = styled.h1`
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px; /* 150% */
  letter-spacing: 0.008px;
  padding-bottom: 16px;
`;
export const Description = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.003px;
`;
export const SkipToSection = styled.section``;
export const FilterTags = styled.section;
export const FeaturedOfferSection = styled.section`
  /* width: 60%;
  align-self: flex-end; */
`;
export const OffersListSection = styled.section``;
